export const socialLinks = {
  facebook: "https://www.facebook.com/tripmerchant/",
  linkedin: "https://www.linkedin.com/company/trip-merchant/",
  youtube:
    "https://www.youtube.com/channel/UCF5anXYxZd-aprSinOdQFhA?view_as=subscriber",
  mail: "https://tripmerchant.com/contact-team-form/",
};
